'use client';

import { Button, Dialog, Textarea, ButtonGroup } from '@/_components';
import { useState, type FC, type ChangeEvent } from 'react';
import { ReasonDialogProps } from './ReasonDialog.types';

export const ReasonDialog: FC<ReasonDialogProps> = ({
  isOpen,
  onClose,
  onSubmit,
}) => {
  const [reason, setReason] = useState<string>('');

  const handleSubmit = (): void => {
    onSubmit(reason);
    setReason('');
    onClose();
  };

  return (
    <Dialog isOpen={isOpen} onClose={onClose} title="Reason for changes">
      <Dialog.Content>
        <Textarea
          label="Please provide a reason for requesting changes to this tax return"
          value={reason}
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
            setReason(e.target.value)
          }
          placeholder="Enter your reason..."
          rows={4}
        />
      </Dialog.Content>
      <Dialog.Footer>
        <ButtonGroup align="right">
          <Button value="Cancel" intent="white-fill" onClick={onClose} />
          <Button
            value="Request Changes"
            intent="primary"
            onClick={handleSubmit}
            isDisabled={!reason.trim()}
          />
        </ButtonGroup>
      </Dialog.Footer>
    </Dialog>
  );
};
